import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UserService } from '../services/user.service';
import { CurrentUser } from '../models/currentUser.model';
import { MatDialog } from '@angular/material/dialog';
import { AppMenuComponent } from '../app-menu/app-menu.component';
import { AppMenuItem } from '../models/app-menu-item';
import { Router } from '@angular/router';
import { MenuService } from '../services/menu.service';
import { Menu } from '../models/menu.model';
import { Language } from '../models/language';
import { EnviromentService } from '../services/enviroment.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-navigaion-header',
  templateUrl: './navigaion-header.component.html',
  styleUrls: ['./navigaion-header.component.scss']
})
export class NavigaionHeaderComponent implements OnInit {  
  @Input() title: string = environment.title;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onAppSelected: EventEmitter<AppMenuItem> = new EventEmitter<AppMenuItem>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onMenuToggle = new EventEmitter<boolean>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onLanguageSelect = new EventEmitter<Language>();

  private SelectedAppKey = 'SELECTEDAPP';

  currentUser: CurrentUser;
  Apps: Menu[];
  Languages: Language[] = [
    {
      code: 'si',
      name: 'SLO',
      icon: 'language-si'
    },
    {
      code: 'hr',
      name: 'HRV',
      icon: 'language-hr'
    },
    {
      code: 'en',
      name: 'ENG',
      icon: 'language-en'
    },
    {
      code: 'de',
      name: 'GER',
      icon: 'language-de'
    }
  ];
  private isSideNavOpened = false;
  selectedLanguage: Language = null;

  constructor(
    private userService: UserService,
    public menuService: MenuService,
    private router: Router,
    private enviromentService: EnviromentService,
    public appDialog: MatDialog
    ) {
      this.userService.user$.subscribe((user) => {
        this.currentUser =  user;
        this.onChangeUser();
      });
    }

  selectApp(app: AppMenuItem): void {
    if (app && this.userService.isLoggedIn()) {
      this.enviromentService.storeLocal(this.SelectedAppKey, app.id);
      this.onAppSelected.emit(app);
    }
  }

  get isUserLogined(): boolean {
    return this.isLoggedIn();
  }

  onChangeUser() {
    setTimeout(() => {
      if (this.userService.isLoggedIn()) {
        this.menuService.GetApps(true).subscribe((result) => {
          const currentApp = this.enviromentService.getLocal(this.SelectedAppKey);
          let currentAppIndex = -99;
          this.Apps = result;
          if(this.Apps && this.Apps.length > 0 && currentApp) {
            currentAppIndex = this.Apps.findIndex(f => f.id === currentApp);
          }

          if(this.Apps && currentAppIndex >= 0) {
            this.selectApp(<AppMenuItem>(this.Apps[currentAppIndex]));
          }
          else if (this.Apps && this.Apps.length > 0) {
            this.selectApp(<AppMenuItem>(this.Apps[0]));
          }
        });
      } else {
        this.userService.logout();
      }
    }, 0);
  }
  ngOnInit() {
    if (!this.selectedLanguage) {
      let language: Language = this.enviromentService.getLanguage();
      if (!language) {
        language = this.Languages[0];
      }
      this.selectLanguage(language);
    }
  }
  logout() {
    this.userService.logout();
    this.selectApp(null);
    this.router.navigate(['']);
  }
  goHome() {
    this.router.navigate(['/home']);
  }

  isLoggedIn(): boolean {
    return (this.currentUser && this.userService.isLoggedIn());
  }

  onToggleSidenav(): void {
    this.isSideNavOpened = !this.isSideNavOpened;
    const value: boolean = this.isSideNavOpened;
    this.onMenuToggle.emit(value);
  }

  selectLanguage(language: Language) {
    this.selectedLanguage = language;
    this.enviromentService.setLanguage(language);
    this.onLanguageSelect.emit(language);
  }
}
